export const APPOINTMENT_TYPE = {
  MEDICATION_REQUEST_INITIAL: "initial",
  MEDICATION_REQUEST_FOLLOW_UP: "follow_up",
  JOURNEY_SUPPORT: "journey_support",
  JOURNEY_SUPPORT_INITIAL: "journey_support_initial", // TODO: Only used for scheduling. Refactor BE
  JOURNEY_SUPPORT_FOLLOW_UP: "journey_support_follow_up", // TODO: Only used for scheduling. Refactor BE
  DIETITIAN: "dietitian",
  TESTOSTERONE: "testosterone_replacement_therapy",
  OTHER: "other",
} as const;

export const MEDICATION_REQUEST_APPOINTMENT_TYPES = [
  APPOINTMENT_TYPE.MEDICATION_REQUEST_INITIAL,
  APPOINTMENT_TYPE.MEDICATION_REQUEST_FOLLOW_UP,
  APPOINTMENT_TYPE.OTHER,
] as const;

export const POST_MEETING_STATUS = {
  OCCURRED: "Occurred",
  CANCELLED: "Cancelled",
  LATE_CANCELLATION: "Late-Cancellation",
  NO_SHOW: "No-Show",
  RE_SCHEDULED: "Re-Scheduled",
} as const;
